import { format } from "date-fns";
import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { FaRegCheckCircle } from "react-icons/fa";
import { TbHandClick } from "react-icons/tb";
import { formatToIndianNumber, toInitials } from "../../utilities";
import { Link } from "react-router-dom";
import { IoMdAdd } from "react-icons/io";
import { Popover } from "@mui/material";
import { updateEmployeeSalaryApi } from "../../services/salaryService";
import { toast } from "react-toastify";
const EmployeeSalaryTable = ({
  employees,
  setEmployees,
  onPayEmployee,
  selectedEmployees,
  onSelectEmployee,
  onSelectAll,
}) => {
  const [clickEmployee, setClickEmployee] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [form, setForm] = useState({
    overtime: "",
    deductions: "",
  });

  const resetForm = () => {
    setForm({
      overtime: "",
      deductions: "",
    });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const actionMenuOpen = Boolean(anchorEl);
  const handleActionClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setClickEmployee(item);
    // setForm({
    //   overtime: Number(item?.overtime) || "",
    //   deductions: Number(item?.deductions) || "",
    // });
  };

  const handleActionClose = () => {
    setAnchorEl(null);
    setClickEmployee(null);
    resetForm();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const pendingEmployees = employees.filter(
    (emp) => emp?.payment_status?.toLowerCase() === "pending"
  );
  const allPendingSelected =
    pendingEmployees?.length > 0 &&
    pendingEmployees.every((emp) =>
      selectedEmployees?.some((item) => item?.id == emp.id)
    );

  const updateSalary = () => {
    setUpdateLoading(true);
    updateEmployeeSalaryApi({ payroll_id: clickEmployee?.id, ...form })
      .then((res) => {
        const resData = res?.data?.results || null;
        handleActionClose();
        if (!resData) return;
        setEmployees((prev) =>
          prev.map((item) =>
            item?.id == resData?.payroll_id
              ? {
                  ...item,
                  net_salary: resData?.net_salary,
                  deductions: resData?.deductions,
                  overtime: resData?.overtime,
                }
              : item
          )
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setUpdateLoading(false));
  };
  return (
    <div className="table-responsive">
      <table className="table align-middle fs-6 mb-0">
        <thead className="table-light custom-thead">
          <tr>
            <th style={{ width: "40px" }}>
              <Form.Check
                type="checkbox"
                checked={allPendingSelected}
                onChange={(e) => onSelectAll(e.target.checked)}
                disabled={pendingEmployees.length === 0}
              />
            </th>
            <th style={{ minWidth: "150px" }}>Employee</th>
            <th style={{ minWidth: "150px" }}>Service Center</th>
            <th>Attendance</th>
            <th>Base Salary</th>
            <th>Advance</th>
            <th>Bonus</th>
            <th>Deduction</th>
            <th>Net Salary</th>
            <th>Payment Date</th>
            <th className="text-end" style={{ minWidth: "120px" }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => (
            <tr key={employee.id}>
              <td>
                <div className="d-flex gap-2 align-items-center">
                  <Form.Check
                    type="checkbox"
                    checked={selectedEmployees.some(
                      (item) => item?.id == employee.id
                    )}
                    onChange={(e) => onSelectEmployee(employee)}
                    disabled={
                      employee?.payment_status?.toLowerCase() === "paid"
                    }
                  />
                  <button
                    className="btn btn-outline-light rounded-2"
                    style={{ padding: "0.2rem" }}
                    onClick={(e) => handleActionClick(e, employee)}
                    title="Manage salary"
                    disabled={employee?.payment_status?.toLowerCase()!== "pending"}
                    
                  >
                    <IoMdAdd className="text-darker" />
                  </button>
                </div>
              </td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                    style={{
                      width: "38px",
                      height: "38px",
                      fontWeight: 500,
                      fontSize: "0.9rem",
                    }}
                  >
                    <span>{toInitials(employee?.employee_name)}</span>
                  </div>
                  <div>
                    <Link className="text-uppercase text-primary fw-bold d-block">
                      {employee?.employee_name}
                    </Link>
                    <Link className="small text-secondary d-block">
                      {employee?.employee_email || "-"}
                    </Link>
                  </div>
                </div>
              </td>
              <td>{employee?.service_center_name || "-"}</td>
              <td>
                <div className="text-dark">
                  {employee?.present_days} {"/"} {employee?.total_days} days
                </div>
              </td>
              <td className="fw-semibold">
                ₹{formatToIndianNumber(employee?.base_salary)}
              </td>
              <td className="fw-semibold">
                ₹{formatToIndianNumber(employee?.advances)}
              </td>
               <td className="fw-semibold">
                ₹{formatToIndianNumber(employee?.overtime)}
              </td>
               <td className="fw-semibold">
                ₹{formatToIndianNumber(employee?.deductions)}
              </td>
              <td className="fw-semibold">
                ₹{formatToIndianNumber(employee?.net_salary)}
              </td>
              <td>
                {employee?.paid_at ? (
                  <div>{format(employee?.paid_at, "dd MMM yyyy")}</div>
                ) : (
                  <span className="text-dark">Not paid</span>
                )}
              </td>
              <td className="text-end">
                {(employee?.payment_status?.toLowerCase() === "pending"||employee?.payment_status?.toLowerCase() === "unpaid") ? (
                  <span
                    className="btn btn-sm btn-outline-primary rounded-pill"
                    onClick={() => onPayEmployee(employee)}
                    style={{ padding: "0rem 0.5rem" }}
                  >
                    <TbHandClick className="me-1" />
                    Pay Now
                  </span>
                ) : (
                  <span className="badge text-bg-success-soft rounded-pill">
                    <FaRegCheckCircle className="me-1" />
                    Completed
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {employees.length === 0 && (
        <div className="text-center py-5 text-muted">
          No employees found matching your criteria.
        </div>
      )}

      <Popover
        className="scroll-container"
        open={actionMenuOpen}
        anchorEl={anchorEl}
        onClose={handleActionClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
            borderRadius: "12px",
            width: {
              xs: "80vw",
            },
            minWidth: { sm: "260px" },
            maxWidth: { sm: "330px" },
          },
        }}
      >
        <div className="p-3">
          <div className="mb-2 alert alert-warning rounded-2">
            <h6 className="mb-1 fw-bold">Employee Allowance & Penalty</h6>
            <p className="text-dark mb-0" style={{ fontSize: "0.8rem" }}>
              Adjust employee salary by adding bonus or applying deductions.
            </p>
          </div>
          <div className="mb-1">
            <label className="form-label mb-1 text-dark">Bonus Amount</label>
            <input
              type="text"
              className="form-control"
              name="overtime"
              value={form?.overtime}
              placeholder="e.g. ₹2000"
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  handleInputChange(e);
                }
              }}
            />
          </div>
          <div className="mb-3">
            <label className="form-label mb-1 text-dark">Penalty Amount</label>
            <input
              type="text"
              className="form-control"
              name="deductions"
              value={form?.deductions}
              placeholder="e.g. ₹1000"
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  handleInputChange(e);
                }
              }}
            />
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn stylish-transparent-btn rounded-3 flex-fill"
              onClick={handleActionClose}
              disabled={updateLoading}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary flex-fill rounded-3"
              onClick={updateSalary}
              disabled={!(form?.overtime || form?.deductions)}
            >
              {updateLoading && (
                <Spinner animation="border" size="sm" className="me-1" />
              )}
              Submit
            </button>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default EmployeeSalaryTable;
